<template>
    <div class="job-detail">
        <div class="job-content">
            <div class="detail-content">
                <h2>{{jobInfo.title}}</h2>
                <h6>{{getDate(jobInfo.update_time)}}</h6>
                <div v-html="jobInfo.content"></div>
                <p>-&nbsp;THE&nbsp;END&nbsp;-</p>
            </div>
            <div class="other-job">
                <p @click="jobDetail(prevJob.id)" v-if="prevJob!=null">上一篇&nbsp;:&nbsp;{{prevJob.title}}</p>
                <p @click="jobDetail(nextJob.id)" v-if="nextJob!=null">下一篇&nbsp;:&nbsp;{{nextJob.title}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'JobDetail',
    props: {
        jobInfo: Object,
        prevJob: Object,
        nextJob: Object
    },
    data () {
        return {
            
        }
    },
    methods: {
        getDate (time) {
            var  date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() + ' ';
            return Y+M+D;
        },
        jobDetail (id) {
            this.$router.push('/m_job/'+id)
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    .job-detail
        width: 100%
        .job-content
            padding: 0.72rem 4% 10%
            .detail-content
                padding-bottom: 0.22rem
                border-bottom: 1px solid #d6d6d6
                h2
                    font-size: 0.42rem
                    font-weight: 800
                    color: #333
                    margin-bottom: 0.46rem
                    letter-spacing: 1px
                h6
                    font-size: 0.24rem
                    color: #999
                    margin-bottom: 0.46rem
                    border-bottom: 1px solid #f5f5f5
                    padding-bottom: 0.48rem
                .message
                    color: $black
                    font-size: 0.34rem
                    line-height: 1.4em
                .detail-text
                    margin-top: 5%
                    font-size: 0.34rem
                    color: #666
                    line-height: 1.6em
                    h3
                        font-weight: 800
                        color: $black
                        line-height: 2em
                    ol
                        margin-left: 1.2em
                        margin-bottom: 2em
                        li
                            list-style: decimal
                >p
                    margin-top: 3em
                    text-align: center
                    font-size: 0.25rem
                    color: #333
            .other-job
                margin-top: 4%
                p
                    color: #666
                    font-size: 0.28rem
                    line-height: 2em
</style>


// WEBPACK FOOTER //
// src/components/mobile/JobDetail.vue